/**
 * Denis Callinan
 * Project Andromeda
 * August 2nd, 2020
 * Portfolio.js - Section for my portfolio
 */

import React from 'react';

// Components
import SectionHeader from '../components/SectionHeader/SectionHeader.js';
import ProjectBox from '../components/ProjectBox/ProjectBox'

// Info
import data from '../info/proj.json';

export default class Portfolio extends React.Component {
    render() {
        var inc = -1;
        var boxes = data.map(project => {
            inc++;
        return <ProjectBox 
            width = {this.props.state.windowWidth}
            name = {project["name"]}
            desc = {project["desc"]}
            skills = {project["skills"]}
            gh = {project["link"]}
            src = {project["photo"]} 
            type = {inc}
            />
        })

        return(
            <div className = "page" id = "page-D">
                <SectionHeader sectionID = "portfolio-break" title = "PORTFOLIO" />
                {boxes}
            </div>
        );
    }
}